angular.module('shared').factory('SmsValidationService', ["$filter", function($filter) {
  return {
    clean: function(content) {
      var cleanContent, mergeTagPlaceholder;
      cleanContent = this.decodeHTML($filter('sanitizeEditorField')(content || ''));
      mergeTagPlaceholder = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].join('');
      return cleanContent.replace(/(<mark>.+?<\/mark>)/g, mergeTagPlaceholder);
    },
    decodeHTML: function(html) {
      if (!this.txt) {
        this.txt = document.createElement('textarea');
      }
      this.txt.innerHTML = html;
      return this.txt.value;
    },
    getMessagesCount: function(content) {
      var optimizedContent;
      optimizedContent = this.clean(content).replace(/“|”|’|`|‘/g, '\'').replace(/–|—/g, '-').replace(/•/g, '*');
      if (this.containsNonLatinCodepoints(optimizedContent)) {
        if (optimizedContent.length <= 70) {
          return 1;
        } else {
          return Math.ceil(optimizedContent.length / 67);
        }
      } else {
        if (optimizedContent.length <= 160) {
          return 1;
        } else {
          return Math.ceil(optimizedContent.length / 153);
        }
      }
    },
    containsNonLatinCodepoints: function(s) {
      return /[^\u0000-\u00ff]/.test(s);
    },
    getRemainingCharacters: function(content) {
      return 650 - this.clean(content).length;
    },
    isLengthValid: function(content) {
      return this.getRemainingCharacters(content) >= 0;
    },
    displayRemainingCharacters: function(content) {
      var charactersLabel, remaining;
      remaining = this.getRemainingCharacters(content);
      charactersLabel = remaining === 1 || remaining === (-1) ? 'character' : 'characters';
      if (remaining >= 0) {
        return `${this.clean(content).length} chars (approx. ${this.getMessagesCount(content)} messages), ${remaining} chars remaining.`;
      } else {
        return `Character limit exceeded: please remove ${-remaining} ${charactersLabel}.`;
      }
    },
    getErrors: function(message) {
      var ref;
      if (message.channel === 'sms' && ((ref = message.content) != null ? ref.toLocaleLowerCase().indexOf('bit.ly') : void 0) >= 0) {
        return 'Please use full URLs instead of bit.ly links.';
      }
    }
  };
}]);
